import React, { useState, useEffect } from 'react';
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap';
import { FilterAlt } from 'styled-icons/material';
import { Container } from './styles';

interface Props {
  setDataToFilter: React.Dispatch<React.SetStateAction<any[] | null>>;
  placeholderInput: string;
  nameFieldToFilter?: string;
  copyData?: any[] | null;
}

const FilterTextPriceList: React.FC<Props> = ({
  nameFieldToFilter,
  setDataToFilter,
  copyData,
  placeholderInput
}) => {
  const [inputSearch, setInputSearch] = useState<string>('');
  const [filtered, setFiltered] = useState<boolean>(false);
  const searchHandle = async (textSearch: string) => {
    if (!nameFieldToFilter) return;
    const searchTerm = textSearch.trim().toLowerCase();

    if (!searchTerm) setDataToFilter(copyData || []);
    // Verifica se o campo de pesquisa está vazio e define os dados filtrados como todos os dados copiados

    // eslint-disable-next-line no-param-reassign
    // setDataToFilter((prev: any[] | null) => {
    //   if (!prev || !copyData) return [];

    //   copyData.forEach((item, index) => {
    //     const matchingPrevItem = prev.find(p => p.ProductId === item.ProductId);
    //     if (matchingPrevItem) {
    //       // Verifica se há diferenças entre o item atual e o matchingPrevItem
    //       const hasDifferences = Object.keys(matchingPrevItem).some(key => {
    //         const result = matchingPrevItem[key] !== item[key];
    //         return result;
    //       });

    //       if (hasDifferences) {
    //         // Atualiza o item no copyData somente se houver diferenças
    //         // eslint-disable-next-line no-param-reassign
    //         copyData[index] = { ...item, ...matchingPrevItem };
    //       }
    //     }
    //   });

    //   return prev;
    // });
    const filterFunction = (product: any) =>
      nameFieldToFilter.includes(',')
        ? nameFieldToFilter.split(',').some(field => {
            const result = `${product[field]}`
              .toLowerCase()
              .trim()
              .includes(searchTerm);

            return result;
          })
        : `${product[nameFieldToFilter]}`
            .toLowerCase()
            .trim()
            .includes(searchTerm);

    const dataFiltered = copyData?.filter(filterFunction);

    setFiltered(!dataFiltered?.length);

    const result = dataFiltered?.sort((a, b) => a.Id - b.Id);
    setDataToFilter(result || []);
  };

  return (
    <Container>
      <Row className="sm-margin-bottom">
        <Col xs={12}>
          <InputGroup>
            <Form.Control
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setInputSearch(event.target.value);
                searchHandle(event.target.value);
              }}
              value={inputSearch}
              placeholder={placeholderInput}
            />
            <Button
              variant="outline-primary"
              onClick={() => {
                searchHandle(inputSearch);
              }}
            >
              <FilterAlt width="24px" />
            </Button>
          </InputGroup>
        </Col>
      </Row>
      {filtered && (
        <Row>
          <Col xs={12}>
            <br />
            <h3>Nenhum registro retornado</h3>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default FilterTextPriceList;
